import { render } from "./GlobalConfirmDialog.vue?vue&type=template&id=aad7e1fe&scoped=true"
import script from "./GlobalConfirmDialog.vue?vue&type=script&lang=js"
export * from "./GlobalConfirmDialog.vue?vue&type=script&lang=js"

import "./GlobalConfirmDialog.vue?vue&type=style&index=0&id=aad7e1fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad7e1fe"]])

export default __exports__